export default __webpack_public_path__ + "static/media/wape.2a12db20.png";